<template>
    <div class="editor_panel">
        <div class="editor_panel-nav">
            <div
                class="editor_panel-nav-item"
                @click="openTemplates"
            >
                <inline-svg
                    alt="template"
                    :src="template_icon"
                />
                <p>{{ $t('editorTemplatesTitle') }}</p>
            </div>
            <Lang />
        </div>
    </div>
</template>

<script>
    import template_icon from '@/assets/icons/panel_icons/template.svg';
    import Lang from '@/components/Global/Language.vue';

    export default {
        data() {
            return {
                template_icon
            }
        },
        methods: {
            openTemplates() {
                this.$router.push({ name: 'templates'});
            }
        },
        components: {
            Lang
        }
    }
</script>